module.exports = __webpack_public_path__ + "static/media/make.a6eba909.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/createReactApp/make.png
// module id = 53
// module chunks = 0